var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('vue-snotify'),_c('v-snackbar',{attrs:{"bottom":"","right":"","value":_vm.updateExists,"timeout":-1,"color":"primary"}},[_vm._v(" Actualización disponible "),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.refreshApp}},[_vm._v(" Recargar ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }